module.exports = __webpack_public_path__ + "img/feedback_time_five_minutes.c8d60550.gif";